import {Cell} from "../Cell";
import React from "react";
import styled from "styled-components";
import {GridType} from "../../types";
import {DIMENSION_GRID} from "../../contants";
import {useSizeItem} from "../../provider/ResizeProvider";

const GameGrid = styled.div<{ columns: number; rows: number; size: number }>`
    display: inline-grid;
    grid-template-columns: ${({ columns, size }) => `repeat(${columns}, ${size}px)`};
    grid-template-rows: ${({ rows, size }) => `repeat(${rows}, ${size}px)`};
    background: rgba(0, 0, 0, 0.3);
    
    @media (min-width: 768px) {
        background: rgba(0, 0, 0, 0.5);
    }
`;

interface Props {
    gridData: GridType;
}

export const Grid = ({gridData}: Props) => {
    const {itemSize} = useSizeItem();

    return (
        <GameGrid columns={DIMENSION_GRID} rows={DIMENSION_GRID} size={itemSize}>
            {gridData.map((row, rowIndex) =>
                row.map((cell, columnIndex) => (
                    <Cell
                        size={itemSize}
                        isHinted={gridData[rowIndex][columnIndex].isHinted}
                        dragItemType={gridData[rowIndex][columnIndex].item}
                        elementPosition={{
                            rowIndex,
                            columnIndex,
                        }}
                        key={`${rowIndex}-${columnIndex}`}
                    />
                ))
            )}
        </GameGrid>
    )
}
